export type {
    SecondFactorMethod,
    SecondFactorProofMethod,
    SecondFactorActionKind,
    SecondFactorStatus,
    BeginSecondFactorActionRequest,
    BeginSecondFactorActionResponse,
    ConfirmSecondFactorActionRequest,
    ConfirmSecondFactorActionResult,
    ConfirmAuthenticatorBindingRequest,
    ConfirmAuthenticatorBindingResponse,
    FinalizeAuthenticatorBindingRequest,
    FinalizeAuthenticatorBindingResponse,
    SecondFactorFlowStep,
} from './types'

export {
    normalizeBackupCode,
    normalizeOtpCode,
    isOtpComplete,
    isBackupCodeComplete,
    needsProofCode,
    isProofCodeReady,
} from './methods'

export type SecondFactorLoginMethod = 'email' | 'totp' | 'backup_code'

export interface TwoFactorChallenge {
    preToken: string
    attempts: number
    timeoutS?: number
    prefix?: string
    availableMethods?: SecondFactorLoginMethod[]
    preferredMethod?: SecondFactorLoginMethod
}

export interface TwoFactorLoginConfirmRequest {
    code: string
    preToken: string
    method?: SecondFactorLoginMethod
}

export const DEFAULT_EMAIL_METHODS: SecondFactorLoginMethod[] = ['email']
export const DEFAULT_TOTP_METHODS: SecondFactorLoginMethod[] = ['totp', 'backup_code']

export const resolveAvailableMethods = (challenge: TwoFactorChallenge): SecondFactorLoginMethod[] => {
    if (challenge.availableMethods && challenge.availableMethods.length > 0) {
        return challenge.availableMethods
    }
    if (challenge.prefix) {
        return DEFAULT_EMAIL_METHODS
    }
    return DEFAULT_TOTP_METHODS
}

export const resolvePreferredMethod = (
    challenge: TwoFactorChallenge,
    available: SecondFactorLoginMethod[]
): SecondFactorLoginMethod => {
    if (challenge.preferredMethod && available.includes(challenge.preferredMethod)) {
        return challenge.preferredMethod
    }
    if (available.includes('totp')) {
        return 'totp'
    }
    return available[0] || 'email'
}
